import getLocation from '@justpark/api/src/requests/getLocation';

const landingLoader = async ({ params, jpApiClient }) => {
  const { url } = params.request;
  const { country, slug } = params.params;

  const { pathname } = new URL(url);

  const { geoLocation, hasError, newSlug } = await jpApiClient(
    getLocation(country, slug, pathname)
  )
    .then(({ data }) => ({ geoLocation: data.data }))
    .catch((error) => ({
      hasError: true,
      newSlug: error?.response?.data?.newSlug
    }));

  return { geoLocation, hasError, newSlug };
};

export default landingLoader;
